import { currencyFormatter } from 'core/helpers/formatters';

/**
 * Formatted amounts for the payment disclosures. When a card processing fee applies (farm; CFM auto
 * since #36200) the price is shown as "$base + $fee CC fees", so `amount` is the fee-free base and the
 * fee fields are set; otherwise `amount` is the plain price and the fee fields stay undefined, which
 * keeps the breakdown hidden.
 */
export const getCardFeeDisclosureAmounts = ({
  price,
  priceBase,
  priceTransactionFee,
  isInstallment,
  remainingPaymentsAmount,
  remainingPaymentsBase,
  remainingPaymentsTransactionFee
}) => ({
  amount: currencyFormatter(priceBase ?? price),
  transactionFee: priceTransactionFee ? currencyFormatter(priceTransactionFee) : undefined,
  remainingPaymentsAmount: isInstallment ? currencyFormatter(remainingPaymentsBase ?? remainingPaymentsAmount) : '0',
  remainingPaymentsTransactionFee: remainingPaymentsTransactionFee
    ? currencyFormatter(remainingPaymentsTransactionFee)
    : undefined,
  remainingPaymentsTotal: remainingPaymentsAmount ? currencyFormatter(remainingPaymentsAmount) : undefined
});
